/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/button-has-type */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import Navbar from 'modules/common/components/navbar';
import NFTCard from 'modules/common/components/card';
import PriceModal from 'modules/common/components/modal';
import { useSelector, useDispatch } from 'react-redux';
import TextField from 'modules/common/components/text-field';
import Pagination from 'modules/common/components/pagination';
import { getMyNFTsSlice } from './slice';
import { getMyNFTsList } from './selectors';

const MyArtworks = () => {
  const dispatch = useDispatch();
  const postsList = useSelector(getMyNFTsList);
  const [isOpen, setIsOpen] = useState(false);
  const [price, setPrice] = useState();
  const [tokenId, setTokenId] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 6;

  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentPosts = postsList.slice(firstPostIndex, lastPostIndex);
  const fetchArtworks = async () => {
    await Promise.resolve(dispatch(getMyNFTsSlice.actions.getMyNFTs()));
  };
  function openModal() {
    setIsOpen(true);
  }
  const resellNFTs = async () => {
    const tokenData = { tokenId, price };
    await Promise.resolve(
      dispatch(getMyNFTsSlice.actions.resellMyNFTs(tokenData))
    );
  };
  useEffect(() => {
    fetchArtworks();
  }, []);
  return (
    <div className="bg-[url('/src/modules/common/assests/images/home-background.png')] bg-no-repeat bg-cover min-h-screen h-fit">
      <Navbar />
      <div className='xl:mt-20 2xl:mt-28 w-full container mx-auto px-24'>
        <div>
          <div className='flex justify-between mt-20'>
            <h1 className="text-2xl lg:text-5xl font-['Poppins'] font-semibold text-white">
              My Artworks
            </h1>
            <div>.</div>
          </div>
          <div className='flex justify-center mt-12'>
            <div className='lg:grid xl:grid-cols-4 gap-16'>
              {currentPosts.map((post) => (
                <div>
                  <NFTCard
                    key={post.token_id}
                    token_id={post.token_id}
                    image={post.image}
                    title={post.name}
                    price={post.price}
                    seller={post.seller}
                    owner={post.currentOwner}
                    modal={openModal}
                    setTokenId={(id) => {
                      setTokenId(id);
                    }}
                  />
                </div>
              ))}
            </div>
            <Pagination
              totalPosts={postsList.length}
              postsPerPage={postsPerPage}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
            />
          </div>
        </div>
      </div>
      <PriceModal
        setIsOpen={(value) => setIsOpen(value)}
        isOpen={isOpen}
        setStep={null}
        setSteps={null}
        steps={null}
        title='Resell this artwork'
      >
        <div className='h-fit'>
          <div className='flex justify-center items-center'>
            <div className='w-full my-8'>
              <TextField
                lable='Price'
                placeholder='0.001 GAC'
                name='price'
                type='number'
                onchange={(e) => {
                  setPrice(e.target.value);
                }}
                value={price}
              />
            </div>
          </div>
          <div className='flex justify-center items-center'>
            <button
              onClick={resellNFTs}
              className='bg-gradient-to-b from-[#274728] to-[#40A838] p-1 shadow-lg shadow-green-500/50 hover:shadow-green-500/75 text-white font-medium hover:text-white px-6 py-3 rounded-lg ease-in duration-300'
            >
              Resell NFT
            </button>
          </div>
        </div>
      </PriceModal>
    </div>
  );
};

export default MyArtworks;
